import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { type Cell, flexRender } from '@tanstack/react-table'

interface DraggableTableCellProps<T> {
  cell: Cell<T, unknown>
}

export function DraggableTableCell<T>({ cell }: DraggableTableCellProps<T>) {
  const { setNodeRef, transform, transition, isDragging } = useSortable({
    id: cell.column.id,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <td
      ref={setNodeRef}
      style={{
        ...style,
        width: cell.column.getSize(),
        minWidth: cell.column.getSize(),
      }}
      className='pl-[20px] pr-2 py-2 text-sm'
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  )
}
